import { render, staticRenderFns } from "./SalesReportsInvoices.vue?vue&type=template&id=0094de46"
import script from "./SalesReportsInvoices.vue?vue&type=script&lang=js"
export * from "./SalesReportsInvoices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports